import { IconButton } from "@mui/material";

import MailIcon from "@mui/icons-material/Mail";
import { AdditionalEmailsDialog } from "../../page/CustomerPage/Passport/AdditionalEmailsDialog/AdditionalEmailsDialog";
import { useDialogBetter } from "../../hooks/useDialogBetter";

/**
 * Button component that opens the additional emails for person
 */
export const AdditionalEmailsButton = ({ personId, companyId, readOnly=true, color = "" }) => {
  const { openDialog: openAdditionalEmailsForPersonDialog } = useDialogBetter();

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    openAdditionalEmailsForPersonDialog({
      Component: AdditionalEmailsDialog,
      componentProps: {
        personId: personId,
        companyId: companyId,
        readOnly: readOnly,
      },
    });
  };

  return (
    <IconButton color={color} onClick={handleClick}>
      <MailIcon />
    </IconButton>
  );
};
